// extracted by mini-css-extract-plugin
module.exports = {"title":"size-module__title___3sfTu","norm":"size-module__norm___16tNh","root":"size-module__root___BdQ0u"};